import { DeliveryPromiseType } from "@omni/types/api/product/bff/shared/enums/deliveryPromiseType.enum";
import { Label } from "@omni/ui/components/Product/Label/label";
import { cn } from "@omni/utils/styles";
import { JSX } from "react";

import { Col } from "@/components/General/Grid/col.component";
import { ProductConfigurationDetailComponent } from "@/components/Product/ProductConfigurationDetail/productConfigurationDetail.component";
import { CartItemModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { DeliveryPromise } from "@/types/service/cart/shared";
import { ProductConfiguration } from "@/utils/productConfiguration/productConfiguration.types";

import { CartItemInfoDeliveryMethod } from "./deliveryMethod/cartItemInfoDeliveryMethod.component";
import { CartItemInfoTitle } from "./title/cartItemInfoTitle.component";

type CartItemInfoProps = {
    deliveryPromise:
        | DeliveryPromise
        | null
        | {
              deliveryPromiseType: DeliveryPromiseType;
              withRemove: boolean;
          };
    productConfiguration?: ProductConfiguration;
    cartItem: CartItemModel;
    ccTooltipInfo: string;
    dsvTooltipInfo: string;
    warrantyDepositTooltipInfo: string;
    promoLabels: Array<JSX.Element>;
};

const CartItemInfo = ({
    cartItem,
    deliveryPromise,
    ccTooltipInfo,
    dsvTooltipInfo,
    warrantyDepositTooltipInfo,
    promoLabels,
    productConfiguration
}: CartItemInfoProps) => {
    const { t } = useGranite();

    return (
        <Col
            xs={9}
            md={6}
        >
            <div className={cn("tw:pb-4 tw:md:pb-0")}>
                <CartItemInfoTitle
                    isConfigurableProduct={!!cartItem.articleConfiguration}
                    isWarrantyDeposit={cartItem.warrantyDeposit}
                    warrantyDepositTooltipInfo={warrantyDepositTooltipInfo}
                    cartItem={cartItem}
                    productConfiguration={productConfiguration}
                />
                {cartItem.product &&
                    cartItem.product.discountPercentage > 0 && (
                        <div className={cn("tw:md:hidden")}>
                            <Label
                                type={"label"}
                                position={"left"}
                                className={cn("tw:text-success")}
                            >
                                <Label.Entry>
                                    {t("promotionLabel.promo")}
                                </Label.Entry>
                                <Label.Entry variant={"secondary"}>
                                    {`${Math.floor(
                                        cartItem.product.discountPercentage
                                    )}%`}
                                </Label.Entry>
                            </Label>
                        </div>
                    )}
                <CartItemInfoDeliveryMethod
                    ccTooltipInfo={ccTooltipInfo}
                    deliveryPromise={deliveryPromise}
                    dsvTooltipInfo={dsvTooltipInfo}
                    isBoxArticle={cartItem.boxArticle}
                    isWarrantyDeposit={cartItem.warrantyDeposit}
                    sku={cartItem.sku}
                    boxLogisticInformation={cartItem.boxLogisticInformation}
                    deliveryType={cartItem?.deliveryType}
                />
                <ProductConfigurationDetailComponent
                    configuration={cartItem.articleConfiguration}
                />
                {promoLabels}
            </div>
        </Col>
    );
};

export default CartItemInfo;
